import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { Sidebar } from "@/components/Sidebar";
import { TheStudio } from "@/pages/TheStudio";
import { TheContentEngine } from "@/pages/TheContentEngine";
import { TheBusiness } from "@/pages/TheBusiness";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  const [activeTab, setActiveTab] = useState("studio");
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initApp = async () => {
      try {
        // Seed database with mock data on first load
        await axios.post(`${API}/seed`);
        setIsLoading(false);
      } catch (e) {
        console.error("Failed to initialize app:", e);
        setIsLoading(false);
      }
    };
    initApp();
  }, []);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "studio":
        return <TheStudio />;
      case "engine":
        return <TheContentEngine />;
      case "business":
        return <TheBusiness />;
      default:
        return <TheStudio />;
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-meta-base flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-2 border-meta-neon border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-meta-text-secondary font-mono text-sm">Initializing MetaDash...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="metadash-app flex min-h-screen bg-meta-base" data-testid="metadash-app">
      {/* Noise overlay for texture */}
      <div className="fixed inset-0 noise-overlay pointer-events-none z-0" />
      
      {/* Sidebar */}
      <Sidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        expanded={sidebarExpanded}
        setExpanded={setSidebarExpanded}
      />

      {/* Main Content */}
      <main
        className="flex-1 p-6 lg:p-8 overflow-auto relative z-10 transition-all duration-300"
        style={{ marginLeft: sidebarExpanded ? "260px" : "80px" }}
        data-testid="main-content"
      >
        {renderActiveTab()}
      </main>

      {/* Toast notifications */}
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#282B30',
            border: '1px solid #3A3E45',
            color: '#FFFFFF',
            fontFamily: 'Fira Code, monospace',
          },
        }}
      />
    </div>
  );
}

export default App;
